import { HeaderOverview, IRenderBarChart, RenderBarChart } from "components";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
} from "../..";
import { useOverview } from "providers/overview";
import { Form } from "antd";
import { useGetPropertyDashboardRepairingGraphPerDay } from "service/dashboard/property/homecare";
import { IData } from "service/dashboard/interface";
import dayjs from "dayjs";

const Workload = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const dailyWorkloadDate = Form.useWatch("dailyWorkloadDate");
  const date = findDate(dailyWorkloadDate);

  const { data, isFetching, isError, error } =
    useGetPropertyDashboardRepairingGraphPerDay({ ...date });

  const getData: IData[] =
    data?.map((e) => {
      const date = dayjs(e.day).date();
      return { name: `${date}`, count: e?.count || 0 };
    }) || [];

  const findNoCount = getData.some((e) => e.count > 0);

  const dataBar: IRenderBarChart = {
    data: getData,
    dataKeyX: "name",
    dataKeyY: "count",
    color: "#BBD649",
  };

  return (
    <WrapperBG>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview title={t("daily-workload")} name="dailyWorkloadDate" />
        {isError ? (
          <ErrorDashboard error={error} height="300px" />
        ) : !data || data.length <= 0 || !findNoCount ? (
          <NoDataDashboard height="300px" />
        ) : (
          <RenderBarChart {...dataBar} />
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default Workload;
